module.exports = __webpack_public_path__ + "static/G1-1e110f8ebe993154dfd6a15cb18cf9a9.png";